// extracted by mini-css-extract-plugin
export default {"productDescription":"tea-z","featuredDescription":"uea-z","description":"vea-z","more":"wea-z","descriptionSku":"xea-z"};